module.exports = __webpack_public_path__ + "static/media/Badge_SvgSiteConnecte_Bronze.a56abaa0.svg";